import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';

const Content = ({ message }) => (
  <Fragment>
    <CircularProgress className="mb-4" color="secondary" />
    <Typography id="progress-dialog-title" align="center" variant="subtitle1">
      {message}
    </Typography>
  </Fragment>
);

const Progress = props => {
  const {
    dialog,
    message = 'Loading some food love stories…',
    show,
    ...other
  } = props;

  return dialog ? (
    <Dialog
      aria-labelledby="progress-dialog-title"
      classes={{
        paper: 'justify-center items-center p-6',
      }}
      disableBackdropClick
      disableEscapeKeyDown
      open={show}
      transitionDuration={{ entering: 300, leaving: 195 }}
      {...other}
    >
      <Content message={message} />
    </Dialog>
  ) : (
    <div
      className={
        show ? 'flex flex-col justify-center items-center p-6' : 'hidden'
      }
      style={{ minHeight: '35vh' }}
    >
      <Content message={message} />
    </div>
  );
};

Progress.propTypes = {
  dialog: PropTypes.bool,
  message: PropTypes.string,
  show: PropTypes.bool.isRequired,
};

export default Progress;
